import { useQuery } from '@tanstack/react-query';
import httpClient from 'api/httpClient';
import { findLeads } from 'api/leads';
import { LeadCandidate } from 'models/LeadCandidate';

const fetchLeads = async (id: string): Promise<LeadCandidate[]> => {
  const path = findLeads(id);
  const response = await httpClient.get<LeadCandidate[]>(path);
  return response.data;
};

const useFindLeads = (id: string) => {
  const query = useQuery({
    queryKey: ['lead/find-leads', { id }],
    queryFn: () => fetchLeads(id),
    enabled: false, // disables automatic fetching
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  return query;
};

export default useFindLeads;
